import type { ReactElement } from 'react';
import { memo } from 'react';

import { CrossIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface ClearFiltersButtonProps {
    onClick: () => void;
}

const ClearFiltersButton = memo(
    ({ onClick }: ClearFiltersButtonProps): ReactElement => (
        <Box>
            <Button
                variant="contained"
                color="primary"
                startIcon={<CrossIcon />}
                onClick={(): void => {
                    onClick();
                }}
            >
                Clear filters
            </Button>
        </Box>
    )
);

ClearFiltersButton.displayName = 'ClearFiltersButton';

export { ClearFiltersButton };
